import React, { Component } from 'react';
import { isEmpty, size } from "lodash";

import { DeleteRounded, AddCircleOutlineRounded, KeyboardReturnOutlined, AddRounded } from '@mui/icons-material';
import { IconButton, 
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Fab, 
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import Currency from '../../common/Currency';
import DeleteDialog from '../../common/DeleteDialog';
import SuppliersAdvanceForm from '../Suppliers/SuppliersAdvanceForm';
import SupplierSingle from '../Suppliers/SupplierSingle';
import AdvanceReturnForm from './AdvanceReturnForm';
import TitleWithEndAction from '../../common/TitleWithEndAction';

class AdvanceReturnsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        openDelete: false,
        selected: {},
    }

    componentDidMount() {
        console.log('===============CDM=====================');
        console.log(this.props.ADVANCE_RETURNS);
        console.log('====================================');
        window.scrollTo(0, 0);
        if(isEmpty(this.props.ADVANCE_RETURNS) ){
            this.props.fetchAdvanceReturns()
        }
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleClose = () => {
		this.setState({ 
            openForm: false,
            openDetails: false,
            openUpdate: false,
            openDelete: false,
            openReturn: false,
            selected: {},
        });
    };    
    filterList = () => {
        const { searchBank, searchBar, ADVANCE_RETURNS, searchMode, searchSupplier } = this.props;
        let list = Object.values(ADVANCE_RETURNS)
        // if( !isEmpty(searchBank) ){
        //     list = list.filter( item => item.advance_bank === searchBank)
        // }
        if( !isEmpty(searchBank.value)) {
            list = list.filter( item => item.advance_bank === searchBank.value)
        }
        if( Array.isArray(searchBank) && !isEmpty(searchBank) ) {
            let itemList = searchBank.map(item => item.value )
            list = list.filter( item => itemList.includes(item.advance_bank))
        }

        if( !isEmpty(searchBar) ){
            list = list.filter( item => item.advance_ref.toLowerCase().includes(searchBar.toLocaleLowerCase()))
        }

        if( !isEmpty(searchMode) ){
            list = list.filter( item => item.advance_payment_mode === searchMode)
        }
        // if( !isEmpty(searchSupplier) ){
        //     list = list.filter( item => item.advance_supplier_id === searchSupplier)
        // }
        if( !isEmpty(searchSupplier.value)) {
            list = list.filter( item => item.advance_supplier_id === searchSupplier.value)
        }
        if( Array.isArray(searchSupplier) && !isEmpty(searchSupplier) ) {
            let itemList = searchSupplier.map(item => item.value )
            list = list.filter( item => itemList.includes(item.advance_supplier_id))
        }
        

        return list
    }
    getAdvancesList = (list) => {
        const { rowsPerPage, page } = this.state;
        const { BANKS, SUPPLIERS } = this.props;

        if (!isEmpty(list)){

            // return Object.values(PAYMENTS).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
                <TableRow hover key={item.advance_id} className="clickable" title="Voir le Détail">
                
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        {item.advance_id.slice(0, 18)}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        {new Date(item.advance_date).toLocaleDateString("fr-FR")}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        {!isEmpty(SUPPLIERS) && !isEmpty(item.advance_supplier_id) ? SUPPLIERS[item.advance_supplier_id].supplier_name : ""}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        {!isEmpty(BANKS) && BANKS[item.advance_bank].bank_name}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        <Currency value={item.advance_amount} />
                    </TableCell>                     
                    {/* <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        <Currency value={item.advance_total_available} />
                    </TableCell>                      */}
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        {item.advance_payment_mode}
                    </TableCell>                     
                    <TableCell onClick={ () => this.setState({openDetails: true, selected: SUPPLIERS[item.advance_supplier_id]}) } >
                        {item.advance_ref}
                    </TableCell>                     
                    {/* <TableCell title="Retour sur Acompte" >
                        {item.advance_total_available > 0 &&
                            <IconButton 
                                size="small" 
                                color="primary"
                                onClick={ () => this.setState({openReturn: true, selected: item}) }
                            >
                                <KeyboardReturnOutlined />
                            </IconButton>
                        } 
                    </TableCell>  */}
                    <TableCell onClick={ () => this.setState({openDelete: true, selected: item}) }>
                        {!item.is_avance &&
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <DeleteRounded />
                            </IconButton> 
                        }
                    </TableCell>      

                </TableRow>
            ) )
        }
    }
    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteAdvanceReturn(selected)
        if(this.props.STATE.advanceReturns.error){
            this.props.notif("error", this.props.STATE.advanceReturns.error)
        } else {
            this.props.notif("success", "Retour sur acompte supprimé")
            this.setState({
                deleteAdvance: false,
                selected: {},
            })
        }
    }
    render() {
        const { openDetails, rowsPerPage, page, openUpdate, openDelete, selected, openForm } = this.state;
        const { BANKS } = this.props;

        let payList = this.filterList()
        return (
            <div>
                {openDetails &&
                    <SupplierSingle
                        tab={2}
                        open={openDetails} 
                        supplier={selected}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {/* {openForm &&
                    <SuppliersAdvanceForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openReturn && !isEmpty(selected) &&
                    <AdvanceReturnForm open={openReturn} handleClose={this.handleClose} {...this.props} {...selected} />
                } */}
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"le retour"}
                        close={this.handleClose}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.advanceReturns.fetching}
                    >
                        Retour du {new Date(selected.advance_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.advance_amount} />
                    </DeleteDialog>
                }
                <Box p={2} >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Fournisseur</TableCell>
                            <TableCell>Banque</TableCell>
                            <TableCell>Montant</TableCell>
                            {/* <TableCell>Reste</TableCell> */}
                            <TableCell>Mode</TableCell>
                            <TableCell>Reference</TableCell>
                            {/* <TableCell>Retour</TableCell> */}
                            <TableCell>Supprimer</TableCell> 
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.getAdvancesList(payList)}
                    </TableBody>
                    {size(payList) > 20 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[20, 50]}
                                    colSpan={8}
                                    count={size(payList)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    }
                </Table> 
                </Box>
            </div>
        );
    }
}

export default AdvanceReturnsList;